import { RouteElement } from '@components'

import { ReactElement } from 'react'
import { Route, Routes } from 'react-router'

import { withRouteLinkClickedListener } from '../../hocs/withRouteLinkClickedListener'
import { RecurringInvoicesRoute } from './enums/recurringInvoicesRoute'
import { RecurringInvoicesList } from './routes/RecurringInvoicesList'
import { RecurringInvoicesListEmpty } from './routes/RecurringInvoicesListEmpty'

export const RecurringInvoices = withRouteLinkClickedListener((): ReactElement => {
  return (
    <Routes>
      <Route
        path={RecurringInvoicesRoute.List}
        element={
          <RouteElement isHashRouter>
            <RecurringInvoicesList />
          </RouteElement>
        }
      />
      <Route
        path={RecurringInvoicesRoute.ListEmpty}
        element={
          <RouteElement isHashRouter>
            <RecurringInvoicesListEmpty />
          </RouteElement>
        }
      />
    </Routes>
  )
})
